/**
 * NAO checkout — datos y constantes compartidas.
 * Módulo hoja sin dependencias. Ver arquitectura en CLAUDE.md §19.
 */

// Cobertura logística de Colombia (departamento → ciudades).
// Si Dropi cambia cobertura, actualizar esta lista manualmente.
//
// LOS NOMBRES TIENEN QUE SER LOS DE DROPI, LETRA POR LETRA. Dropi casa la
// ciudad por nombre exacto: si no la reconoce, el pedido no se despacha y hay
// que corregirlo a mano. Esta cadena es el valor Y la etiqueta del <option>,
// así que lo que ve el cliente es literalmente lo que viaja en el pedido.
// Caso real (sep-2026): "BOGOTA D.C." no casaba y "BOGOTA" sí.
export const colombiaData = {
    AMAZONAS: ["LETICIA", "PUERTO NARIÑO"],
    ANTIOQUIA: ["MEDELLIN", "ENVIGADO", "ITAGUI", "BELLO", "RIONEGRO", "SABANETA", "APARTADO", "TURBO", "CAUCASIA", "CALDAS", "BARBOSA", "GIRARDOTA", "MARINILLA", "LA CEJA", "CARMEN DE VIBORAL"],
    ARAUCA: ["ARAUCA", "ARAUQUITA", "SARAVENA", "TAME"],
    ATLANTICO: ["BARRANQUILLA", "SOLEDAD", "MALAMBO", "PUERTO COLOMBIA", "SABANALARGA", "GALAPA", "BARANOA"],
    BOLIVAR: ["CARTAGENA", "MAGANGUE", "TURBACO", "ARJONA", "EL CARMEN DE BOLIVAR"],
    BOYACA: ["TUNJA", "DUITAMA", "SOGAMOSO", "CHIQUINQUIRA", "PUERTO BOYACA", "PAIPA"],
    CALDAS: ["MANIZALES", "LA DORADA", "RIOSUCIO", "VILLAMARIA", "ANSERMA", "CHINCHINA"],
    CAQUETA: ["FLORENCIA", "SAN VICENTE DEL CAGUAN", "PUERTO RICO"],
    CASANARE: ["YOPAL", "AGUAZUL", "VILLANUEVA", "PAZ DE ARIPORO"],
    CAUCA: ["POPAYAN", "SANTANDER DE QUILICHAO", "PUERTO TEJADA", "PATIA"],
    CESAR: ["VALLEDUPAR", "AGUACHICA", "AGUSTIN CODAZZI", "BOSCONIA", "CURUMANI", "EL COPEY"],
    CHOCO: ["QUIBDO", "ISTMINA", "CONDOTO"],
    CORDOBA: ["MONTERIA", "CERETE", "SAHAGUN", "LORICA", "MONTELIBANO", "PLANETA RICA"],
    CUNDINAMARCA: ["BOGOTA", "SOACHA", "FUSAGASUGA", "FACATATIVA", "CHIA", "ZIPAQUIRA", "GIRARDOT", "MOSQUERA", "MADRID", "FUNZA", "CAJICA", "SOPO", "TOCANCIPA"],
    GUAINIA: ["INIRIDA"],
    GUAVIARE: ["SAN JOSE DEL GUAVIARE"],
    HUILA: ["NEIVA", "PITALITO", "GARZON", "LA PLATA"],
    "LA GUAJIRA": ["RIOHACHA", "MAICAO", "URIBIA", "SAN JUAN DEL CESAR", "FONSECA"],
    MAGDALENA: ["SANTA MARTA", "CIENAGA", "FUNDACION", "EL BANCO", "PLATO"],
    META: ["VILLAVICENCIO", "ACACIAS", "GRANADA", "PUERTO LOPEZ", "CUMARAL"],
    NARINO: ["PASTO", "TUMACO", "IPIALES", "TUQUERRES"],
    "NORTE DE SANTANDER": ["CUCUTA", "OCANA", "VILLA DEL ROSARIO", "LOS PATIOS", "PAMPLONA", "TIBU"],
    PUTUMAYO: ["MOCOA", "PUERTO ASIS", "ORITO"],
    QUINDIO: ["ARMENIA", "CALARCA", "LA TEBAIDA", "MONTENEGRO", "QUIMBAYA"],
    RISARALDA: ["PEREIRA", "DOSQUEBRADAS", "SANTA ROSA DE CABAL", "LA VIRGINIA"],
    "SAN ANDRES Y PROVIDENCIA": ["SAN ANDRES"],
    SANTANDER: ["BUCARAMANGA", "FLORIDABLANCA", "GIRON", "PIEDECUESTA", "BARRANCABERMEJA", "SAN GIL", "SOCORRO"],
    SUCRE: ["SINCELEJO", "COROZAL", "SAN MARCOS", "TOLU"],
    TOLIMA: ["IBAGUE", "ESPINAL", "CHAPARRAL", "LIBANO", "MELGAR", "HONDA"],
    "VALLE DEL CAUCA": ["CALI", "BUENAVENTURA", "PALMIRA", "TULUA", "YUMBO", "CARTAGO", "BUGA", "JAMUNDI", "FLORIDA"],
    VAUPES: ["MITU"],
    VICHADA: ["PUERTO CARREÑO"]
};

// Ciudades que cambiaron de nombre en la lista de arriba. Un borrador guardado
// antes del cambio trae el nombre viejo, que ya no casa con ningun <option>: sin
// esta traduccion el cliente que vuelve se encuentra la ciudad vacia y no sabe
// por que. Al renombrar una ciudad, anadir aqui la equivalencia.
export const CITY_ALIASES = {
    'BOGOTA D.C.': 'BOGOTA'
};

// Vigencia del borrador de checkout guardado en localStorage (24 h).
export const CACHE_EXPIRY = 86400000;

// Campos de contacto sensibles que NO se persisten en localStorage (FASE 7).
// Reduce la exposición de PII en dispositivos compartidos; el resto de la
// dirección se conserva para no obligar a re-teclear todo el formulario.
export const SENSITIVE_KEYS = ['email', 'phone', 'whatsapp_phone'];

// Campos de máquina que tampoco se persisten: no son datos del cliente sino
// estado que la página deriva en cada carga. Restaurar `variant_id` desde el
// borrador de OTRO producto crearía la orden del producto equivocado, y
// `shipping_cost` guardado dejaría un envío obsoleto en el payload.
export const MACHINE_KEYS = ['variant_id', 'shipping_cost'];

// Clave de localStorage por hostname y por producto. El hostname aísla
// dev/preview/producción; la clave de producto evita que el borrador de un
// producto se cargue en el formulario de otro.
export function buildLsKey(formKey) {
    const scope = formKey || 'default';
    return `nao_checkout_${window.location.hostname}_${scope}`;
}
